import React from "react";
import { useSelector } from "react-redux";
import DOMPurify from "dompurify";

const REACT_APP_AWS_URL = process.env.REACT_APP_AWS_URL;

const AboutSection = ({ t }) => {
  const RadioReducer = useSelector((state) => state.RadioReducer);
  const SettingsReducer = useSelector((state) => state.SettingsReducer);
  const d = RadioReducer.single.created_at
    ? new Date(RadioReducer.single.created_at)
    : new Date();
  let year = d.getFullYear();
  const createMarkup = (html) => {
    return {
      __html: DOMPurify.sanitize(html),
    };
  };
  return (
    <section className="section about-part">
      <div className="container__">
        <div className="row">
          <div
            className="col-sm-12 col-md-12 col-lg-5"
            style={{ textAlign: "center" }}
          >
            <div className="about-img">
              <a href="" className="about-1">
                <img
                  src={
                    RadioReducer.single.profile_picture
                      ? `${REACT_APP_AWS_URL}/${RadioReducer.single.profile_picture}`
                      : ""
                  }
                  alt="about-1"
                />
              </a>
              <a href="" className="about-2">
                <img
                  src={
                    RadioReducer.single.cover_picture
                      ? `${REACT_APP_AWS_URL}/${RadioReducer.single.cover_picture}`
                      : ""
                  }
                  alt="about-2"
                />
              </a>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-7">
            <div className="about-content">
              <h2>
                <span>{RadioReducer.single.name}</span> {t("Some About")}
              </h2>
              <div
                className="preview"
                dangerouslySetInnerHTML={createMarkup(
                  SettingsReducer.data
                    ? SettingsReducer.data.about_us
                    : t("loading...")
                )}
              />

              <h3>
                {t("Since")} {year}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
